var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 17.5C34.5 13.6658 33.2039 9.94426 30.8221 6.9396C28.4403 3.93495 25.1127 1.82368 21.3798 0.948643C17.6468 0.0736037 13.7276 0.486182 10.2587 2.11938C6.78976 3.75258 3.97479 6.51049 2.27089 9.94525C0.567 13.38 0.074252 17.2899 0.872665 21.04C1.67108 24.7901 3.71376 28.1602 6.66901 30.603C9.62426 33.0459 13.3185 34.4179 17.1519 34.4964C20.9852 34.575 24.7326 33.3553 27.7854 31.0355L24.5158 26.7328C22.4335 28.3151 19.8773 29.1471 17.2625 29.0935C14.6477 29.04 12.1278 28.1041 10.112 26.4378C8.0962 24.7715 6.70285 22.4727 6.15824 19.9147C5.61363 17.3567 5.94974 14.6897 7.11199 12.3468C8.27424 10.0039 10.1944 8.12268 12.5606 7.00864C14.9268 5.89461 17.6001 5.61319 20.1464 6.21007C22.6928 6.80694 24.9625 8.24707 26.5872 10.2966C28.2119 12.3461 29.096 14.8847 29.096 17.5H34.5Z",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 17.5 17.5",
    to: "360 17.5 17.5",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderWhite);
export default __webpack_public_path__ + "static/media/loader-white.ed57ccb87974cf4bc70b8b3e6c9e8872.svg";
export { ForwardRef as ReactComponent };